module.exports = __webpack_public_path__ + "static/media/LogOut.838d921b.svg";